import { useState, useRef, Fragment } from "react";
import Config from "../../Config";

import PlTitle from "../../elements/PlTitle";


import InputComboGrupa from "../../helpers/InputComboGrupa";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputComboRok from "../../helpers/InputComboRok";
import InputComboMiesiac from "../../helpers/InputComboMiesiac";

import XDateFee from "../kids/XDateFee";
import XTime from "../kids/XTime";

import FormatTime from "../../helpers/FormatTime";

import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import AppContext from "../../AppContext";

import HourEditE from "./HourEditE";

function Hour(props)
{

    const tabRef = useRef(0);
    const tab2Ref = useRef(0);
    
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filter, setFilter] = useState(null);
    const [view, setView] = useState(props.view);
    const [filterParam, setFilterParam] = useState({
        p_imie_nazwisko: props.mainView.readFilter('p_imie_nazwisko',''),    
      
        rok: (new Date()).getFullYear() ,
        miesiac: (new Date() ).getMonth()+1,       
        limit: 50,
        page: 1,
        pages: 1,
        show: !props.mainView.isMobile(), 
    });
    const [tab, setTab] = useState(null);




    var dt = new Date();
    const [showDay, setShowDay] = useState({
        from: dt.getDate() - 3,
        to: dt.getDate() + 3,
    });
    const [strToDay, setStrToDate] = useState( dt.toISOString().split`T`[0]  ); 


    const showAllDays = () => {

        if(showDay.from == -1)
            {
                var dt = new Date();
                setShowDay({
                    from: dt.getDate() - 3,
                    to: dt.getDate() + 3,
                });

                props.mainView.changeMenuStatus(1);
                return;
            }


            props.mainView.changeMenuStatus(0);
        setShowDay({
            from: -1,
            to: 32
        });

    }

 



    const valChangeListener = (filedName, val, correct, msg) => {

        // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
 
         setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
         
         if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }

         props.mainView.writeFilter(filedName, val);
     }



     const goNextNew = () => {
           
        setTab(null);    
    }

    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }


    const filterClear = () => {

        props.mainView.writeFilter('p_imie_nazwisko', '');
        
        setFilterParam({
            p_imie_nazwisko: '', 
           
            rok: (new Date()).getFullYear() ,
            miesiac: (new Date() ).getMonth()+1,         
            limit: 50,
            page: 1,
            show:true, 
        });
        setTab(null);


    }

    const filterApprove = () => {   
        setTab(null)     
    }




    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_employessModule,hour', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);            
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
                    setTab('false');       
         });
                   

         return false;
    }

    if(tab === null)
        {
            getTab();
         
    
            return <div>
                ...
            </div>
        }
 

        var iloscRoz   = 0;

        

        return (
            <div className="view_content">
                   


                   {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
                } 

                {
                    filterParam.show == true  &&
                    <div className="  goright link_color" onClick={filterView}>
                        ukryj filtry
                    </div>
                } 

                      {
                            filterParam.show == true  &&
                            <div className="table_filter">
               
                         
                        
                            
                          
                         
                            <div className="filter_controll">   
                                <label>Rok: </label>                             
                                <InputComboRok   userData={props.userData}  mainView={props.mainView}  value={filterParam.rok}   valChange={valChangeListener} goNext={goNextNew} name="rok" placeholder={": "}  noempty="1"   />
                            </div> 

                            <div className="filter_controll">   
                                <label>Miesiąc: </label>                             
                                <InputComboMiesiac   userData={props.userData}  mainView={props.mainView}  value={filterParam.miesiac}   valChange={valChangeListener} goNext={goNextNew} name="miesiac" placeholder={": "}  noempty="1"   />
                            </div> 


                            <div className="filter_btn">
                               
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                            </div>

                          </div>
                          
                        }     

                    
                        <div className="filter_btn ">
                           
                            <HourEditE mainView={props.mainView} view={view} userData={props.userData} row={tab}  className={"gocenter nbx_squre txtcloud "}  onSucess={getTab} title={ tab.nazwisko + " " + tab.imie } ></HourEditE>    
                        
                        </div>

               

                <div className=" bg_center">

 
                <div ref={tabRef} >
                         <h3>Godziny pracy {filterParam.rok + "-" + filterParam.miesiac }</h3>   

                         <table className="table" ref={tab2Ref} >
                                                    <thead>
                                                        <tr className="header">
                                                            <td>Data</td>  
                                                            <td>Godzina wejścia</td>  
                                                            <td>Godzina wyjścia</td>  
                                                            <td>Godziny</td>  
                                                        </tr>


                                                        
                                                    </thead>

                                                    <tbody>


                                                           {
                                                            


                                                                tab.dni.map( (dd, ir) => {

                                                                var clsTD = " e_square_center ";
                                                                var clsSquare = "e_ob_def";


                                                                if(dd.w == '6')      clsTD ="e_square_center e_squere_sb";
                                                                if(dd.w == '0')      clsTD ="e_square_center e_squere_nd";
                                                                if(dd.wolne == '1')  clsTD ="e_square_center e_squere_free";

                                                                if(dd.dzien == strToDay)     clsTD = clsTD + " e_squere_today ";

                                                                iloscRoz = parseFloat( iloscRoz + dd.minuty ) ; 

                                                                if(dd.minuty > 0) clsTD = clsTD + " txt_show ";

                                                                

                                                                return <tr className="row">
                                                                      
                                                                            <td className={clsTD + " txtcloud "} >{dd.dzien}</td>                                                  
                                                                            <td  className={clsTD + " txtcloud "}>{dd.wejscie}</td>
                                                                            <td  className={clsTD + " txtcloud "}>{dd.wyjscie}</td>
                                                                      
                                                                            <td  className={clsTD + " txtcloud gobold "}> <FormatTime minute={dd.minuty} /> </td>   
                                                                 

                                                                        </tr>                                                                                                                                       

                                                            } )     
                                                                                                                              
                                                                                                                        
                                                            }

                                                                <tr className="row">
                                                                      
                                                                      <td className={" txtcloud e_square_center  "} ><b>RAZEM:</b></td>                                                  
                                                                      <td  className={" txtcloud "}></td>
                                                                      <td  className={" txtcloud "}></td>
                                                                
                                                                      <td  className={" txtcloud e_square_center   gobold "}> <FormatTime minute={tab.razem.minuty} /> </td>   
                                                           

                                                                  </tr>
                                                            
        

                                                    </tbody>

                            </table>
                </div>



                    
                </div>



            </div>
        )
}

export default Hour;